import axios from '../config/axios';
import { BASE_URL } from '../config/constants';
import { handleError } from './LoginAction';
import { SHOW_NOTIFICATION } from './UIElementsAction';

export const listSubCategoryItemAction = (params, cb) => (dispatch) => {
    axios.get(BASE_URL + '/admin/sub-category-item/list', {
        params: params
    }).then((response) => {
        if (cb) {
            return cb(null, response);
        }
    }).catch(err => {
        handleError(dispatch, err);
        if (cb) {
            return cb(err);
        }
    })
}


export const createSubCategoryItemAction = (params, cb) => (dispatch) => {
    axios.post(BASE_URL + '/admin/sub-category-item/create', params).then((response) => {
        dispatch({
            type: SHOW_NOTIFICATION,
            payload: {
                type: "success",
                position: "top-right",
                dialogText: response.data.message,
                show: true,
            },
        });
        if (cb) {
            return cb(null, response);
        }
    }).catch(err => {
        handleError(dispatch, err);
        if (cb) {
            return cb(err);
        }
    })
}
export const updateSubCategoryItemAction = (id, params, cb) => (dispatch) => {
    axios.put(BASE_URL + `/admin/sub-category-item/update?id=${id}`, params).then((response) => {
        dispatch({
            type: SHOW_NOTIFICATION,
            payload: {
                type: "success",
                position: "top-right",
                dialogText: response.data.message,
                show: true,
            },
        });
        if (cb) {
            return cb(null, response);
        }
    }).catch(err => {
        handleError(dispatch, err);
        if (cb) {
            return cb(err);
        }
    })
}


export const viewSubCategoryItemAction = (params, cb) => (dispatch) => {
    axios.get(BASE_URL + '/admin/sub-category-item/view', {
        params: params
    }).then((response) => {
        console.log(response,"here response");
        if (cb) {
            return cb(null, response);
        }
    }).catch(err => {
        handleError(dispatch, err);
        if (cb) {
            return cb(err);
        }
    })
}

export const deleteSubCategoryItemAction = (params, cb) => (dispatch) => {
    axios.post(BASE_URL + '/admin/sub-category-item/delete', params).then((response) => {
        dispatch({
            type: SHOW_NOTIFICATION,
            payload: {
                type: "success",
                position: "top-right",
                dialogText: response.data.message,
                show: true,
            },
        });
        if (cb) {
            return cb(null, response);
        }
    }).catch(err => {
        handleError(dispatch, err);
        if (cb) {
            return cb(err);
        }
    })
}